import React from "react";
import { createPortal } from "react-dom";
import { FaTimes, FaExclamationTriangle } from "react-icons/fa";

const DeactivateAppAccessModal = ({ patient, onClose, onConfirm, isSubmitting }) => {
  if (!patient) return null;

  return createPortal(
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.45)",
        zIndex: 1070,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: "#FFFFFF",
          borderRadius: "12px",
          width: "440px",
          maxWidth: "100%",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.18)",
          overflow: "hidden",
          fontFamily: "Poppins, sans-serif",
        }}
      >
        <div
          style={{
            backgroundColor: "#0A3652",
            padding: "18px 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h3 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#FFFFFF" }}>
            Deactivate App Access
          </h3>
          <button
            type="button"
            onClick={onClose}
            disabled={isSubmitting}
            style={{
              background: "none",
              border: "none",
              cursor: isSubmitting ? "not-allowed" : "pointer",
              color: "#FFFFFF",
              padding: "2px",
              display: "flex",
              opacity: isSubmitting ? 0.6 : 1,
            }}
          >
            <FaTimes size={16} />
          </button>
        </div>

        <div style={{ padding: "24px" }}>
          <div
            style={{
              display: "flex",
              gap: "12px",
              alignItems: "flex-start",
              marginBottom: "20px",
            }}
          >
            <FaExclamationTriangle size={20} color="#E74C3C" style={{ marginTop: "2px", flexShrink: 0 }} />
            <p style={{ margin: 0, fontSize: "14px", color: "#4B5563", lineHeight: 1.6 }}>
              This will revoke <strong>{patient.name}</strong>&apos;s access to the Numente app.
              They will no longer be able to use their access code until a new invite is sent.
            </p>
          </div>

          <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
            <button
              type="button"
              onClick={onClose}
              disabled={isSubmitting}
              style={{
                padding: "10px 20px",
                borderRadius: "8px",
                border: "1px solid #EAECEF",
                backgroundColor: "#FFFFFF",
                color: "#064260",
                fontWeight: 600,
                fontSize: "14px",
                cursor: isSubmitting ? "not-allowed" : "pointer",
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={isSubmitting}
              style={{
                padding: "10px 24px",
                borderRadius: "8px",
                border: "none",
                backgroundColor: "#E74C3C",
                color: "#FFFFFF",
                fontWeight: 600,
                fontSize: "14px",
                cursor: isSubmitting ? "not-allowed" : "pointer",
                opacity: isSubmitting ? 0.7 : 1,
              }}
            >
              {isSubmitting ? "Deactivating…" : "Deactivate App Access"}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default DeactivateAppAccessModal;
